/** Canonical share-URL builders. One source of truth for both the client
 * (Share buttons) and the worker (og:url meta), so the link people copy and
 * the link crawlers canonicalise are guaranteed identical. */

export const SITE_ORIGIN = "https://warurna.trinkes.pt";

/** Clean candidate profile — THE share link for a campaign. */
export function candidateShareUrl(username: string): string {
  return `${SITE_ORIGIN}/u/${encodeURIComponent(username)}`;
}

/** All candidates for an office in a country. */
export function raceShareUrl(countryId: string, office: string): string {
  return `${SITE_ORIGIN}/c/${countryId}/race/${office}`;
}

/** Live election forecast. */
export function forecastShareUrl(countryId: string, electionId: string): string {
  return `${SITE_ORIGIN}/c/${countryId}/e/${electionId}`;
}

/** Community poll deeplink. */
export function pollShareUrl(pollId: string): string {
  return `${SITE_ORIGIN}/polls/${pollId}`;
}

/** Relative in-app path for a candidate profile (router links). */
export function candidatePath(username: string): string {
  return `/u/${encodeURIComponent(username)}`;
}

/** Relative in-app path for one specific campaign (nested under the profile). */
export function candidacyPath(username: string, candidacyId: string): string {
  return `/u/${encodeURIComponent(username)}/c/${encodeURIComponent(candidacyId)}`;
}
